;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('FilterPermissionsDropdownController', filterPermissionsDropdownController)

  /* @ngInject */
  function filterPermissionsDropdownController ($scope, $attrs, $timeout) {
    const defaultPermissionsList = Array.from($scope.defaultPermissionsList)

    $scope.permissionsList = defaultPermissionsList
    $scope.permissionSelected = []
    $scope.permissionSelectedCache = []

    const api = {
      _handleToggleDropdown,
      _mergePermissionsList,
      _checkPermissionAlreadyExistsInArray,
      _checkEqualPermissionId,
      _onHideDropdown
    }
    this.getApi = () => api

    activate()

    function activate () {
      const dropdownParams = {
        action: 'nothing',
        direction: 'downward',
        fullTextSearch: true,
        onHide: api._onHideDropdown
      }

      api._handleToggleDropdown(dropdownParams)
    }

    $scope.$watch('params.permissions', (newValue) => {
      $scope.permissionSelected = [...newValue]
      if (newValue.length) {
        api._mergePermissionsList($scope.permissionSelected, $scope.permissionsList)
      } else {
        $scope.permissionsList = defaultPermissionsList
      }
    })

    $scope.handleSelect = (permission) => {
      const index = $scope.permissionSelected.findIndex(permissionSelected => api._checkEqualPermissionId(permissionSelected, permission))
      if (index !== -1) {
        $scope.permissionSelected.splice(index, 1)
      } else {
        $scope.permissionSelected = [permission, ...$scope.permissionSelected]
      }
    }

    $scope.isSelected = (permission) => {
      const hasPermissionSelected = $scope.permissionSelected.find(permissionSelected => api._checkEqualPermissionId(permissionSelected, permission))

      if (hasPermissionSelected) {
        return true
      }

      return false
    }

    $scope.handleRemove = (removeJustSelected) => {
      if (removeJustSelected) {
        $scope.permissionSelectedCache = [...$scope.permissionSelected]
        $scope.permissionSelected = []
        return
      }

      $scope.params.permissions = []
      api._handleToggleDropdown('hide')
    }

    $scope.handleApply = () => {
      if ($scope.permissionSelected.length) {
        $scope.params.permissions = $scope.permissionSelected
      } else {
        $scope.params.permissions = []
      }

      api._handleToggleDropdown('hide')
      $scope.permissionsList = defaultPermissionsList
    }

    /**
     *  @param {object | string} options - config options for semantic dropdown
     *  @description this method open/close the dropdown menu, or initialize it
     */
    function _handleToggleDropdown (options) {
      $timeout(() => {
        $attrs.$$element.find('.ui.dropdown.filter-permissions-dropdown').dropdown(options)
      }, 100, false)
    }

    /**
     *  @typedef {Array} ArrayList
     *  @param {ArrayList} firstArray - items that will be first in the new array of permission
     *  @param {ArrayList} lastArray - items that will be last in the new array of permission
     *  @description this method merge two arrays and create a new array, only serve to merge the array of permission
     */
    function _mergePermissionsList (firstArray, lastArray) {
      const updatedList = lastArray.map(api._checkPermissionAlreadyExistsInArray).filter(Boolean)
      $scope.permissionsList = [...firstArray, ...updatedList]
    }

    /**
     *  @param {object} permission - object of permission
     *  @description this method check if the permission already exists in the array of permission
     */
    function _checkPermissionAlreadyExistsInArray (permission) {
      const index = $scope.permissionSelected.findIndex(selectedPermission => api._checkEqualPermissionId(selectedPermission, permission))
      if (index === -1) {
        return permission
      }
    }

    /**
     *  @param {object} selectedPermission - object of permission
     *  @param {object} permission - object of selectedPermission
     *  @description this method checks if the selectedPermission is equal to the permission
     */
    function _checkEqualPermissionId (selectedPermission, permission) {
      return selectedPermission.id === permission.id
    }

    /**
     *  @description this method is called on hide the semantic dropdown
     */
    function _onHideDropdown () {
      if (!$scope.permissionSelected.length && $scope.permissionSelectedCache.length) {
        $scope.permissionSelected = [...$scope.permissionSelected]
      }
    }
  }
})()
